import type { GestorJornadaMembro } from '@/services/gestoresService'
import { daysUntil } from '@/components/Gestores/gestorJornadaUi'

export type JornadaSituacaoFilter =
  | 'todas'
  | 'atrasadas'
  | 'proximas'
  | 'em_dia'
  | 'sem_historico'
  | 'feedback_rascunho'

export type JornadaViewMode = 'cards' | 'lista'

export const JORNADA_SITUACAO_FILTERS: Array<{ id: JornadaSituacaoFilter; label: string }> = [
  { id: 'todas', label: 'Todos' },
  { id: 'atrasadas', label: 'Atrasadas' },
  { id: 'proximas', label: 'Próximas' },
  { id: 'em_dia', label: 'Em dia' },
  { id: 'sem_historico', label: 'Sem histórico' },
  { id: 'feedback_rascunho', label: 'Rascunho FB' },
]

const SITUACAO_ORDER: Record<GestorJornadaMembro['situacao'], number> = {
  ATRASADA: 0,
  PROXIMA: 1,
  SEM_HISTORICO: 2,
  OK: 3,
}

function matchesSituacaoFilter(membro: GestorJornadaMembro, filter: JornadaSituacaoFilter) {
  if (filter === 'todas') return true
  if (filter === 'atrasadas') return membro.situacao === 'ATRASADA'
  if (filter === 'proximas') return membro.situacao === 'PROXIMA'
  if (filter === 'em_dia') return membro.situacao === 'OK'
  if (filter === 'sem_historico') return membro.situacao === 'SEM_HISTORICO'
  return membro.feedbackResumo.feedbackRascunho > 0
}

export function filterJornadaMembros(
  membros: GestorJornadaMembro[],
  opts: { search: string; situacao: JornadaSituacaoFilter },
) {
  const q = opts.search.trim().toLowerCase()
  return membros.filter((m) => {
    if (!matchesSituacaoFilter(m, opts.situacao)) return false
    if (!q) return true
    const haystack = `${m.nomeCompleto} ${m.setor ?? ''}`.toLowerCase()
    return haystack.includes(q)
  })
}

export function sortJornadaMembros(membros: GestorJornadaMembro[]) {
  return [...membros].sort((a, b) => {
    const orderDiff = SITUACAO_ORDER[a.situacao] - SITUACAO_ORDER[b.situacao]
    if (orderDiff !== 0) return orderDiff

    if (a.situacao === 'ATRASADA' && b.situacao === 'ATRASADA') {
      return daysUntil(a.proximaOneOnOneEm) - daysUntil(b.proximaOneOnOneEm)
    }
    if (a.situacao === 'PROXIMA' && b.situacao === 'PROXIMA') {
      return daysUntil(a.proximaOneOnOneEm) - daysUntil(b.proximaOneOnOneEm)
    }

    return a.nomeCompleto.localeCompare(b.nomeCompleto, 'pt-BR')
  })
}

export function buildJornadaSituacaoCounts(membros: GestorJornadaMembro[]) {
  return {
    todas: membros.length,
    atrasadas: membros.filter((m) => m.situacao === 'ATRASADA').length,
    proximas: membros.filter((m) => m.situacao === 'PROXIMA').length,
    em_dia: membros.filter((m) => m.situacao === 'OK').length,
    sem_historico: membros.filter((m) => m.situacao === 'SEM_HISTORICO').length,
    feedback_rascunho: membros.filter((m) => m.feedbackResumo.feedbackRascunho > 0).length,
  }
}
